import { createFeature, createReducer, on } from '@ngrx/store';
import { IQueryConfigData } from '../query-engine/interfaces/query.interface';
import { QueryConfigActions } from './query-config.actions';

export const queryConfigFeatureKey = 'queryConfig';

export interface State {
  queryConfigData: IQueryConfigData;
  httpResult: { action: string; error?: unknown };
}

export const initialState: State = {
  queryConfigData: {
    name: '',
    config: {
      schema: '',
      select: [],
      where: [],
      order: [],
      limit: 0,
      offset: 0,
      version: 0,
      partialResultAllowed: false,
    },
  },
  httpResult: { action: '' },
};

export const reducer = createReducer(
  initialState,
  on(QueryConfigActions.saveQueryConfigSuccess, (state, { queryConfigData }): State => {
    return { ...state, queryConfigData };
  }),
  on(QueryConfigActions.saveQueryConfigFailure, (state, { error }): State => {
    return { ...state, httpResult: { action: 'Save Query Config Failure', error } };
  })
);

export const queryConfigFeature = createFeature({
  name: queryConfigFeatureKey,
  reducer,
});
